<template>
  <Walkthrough 
    roomName="The Car"
    roomKey="car"
    :steps="steps"
    :backgroundImage="backgroundImage"
  />
</template>
<script>

export default {
  name: 'Car',
  props: ["roomName"],
  data() {
    return {
      backgroundImage: "https://d37bvzh6941o03.cloudfront.net/EscapeTheRoom/images/backgrounds/car-1920x1280.jpg",
      steps: [
        "Look right and then inspect the seat. You should find a screwdriver. ",
        "Look up and then use your screwdriver on the light. After unscrewing the light you should find a knife inside. ",
        "Look down and use your knife on the seatbelt. This should cut you free and allow you to move freely to the front of the car. ",
        "Look left and inspect the cupholder. Looks like someone made a mistake and left you a key. ",
        "Look forward and then use your screwdriver on the dashpanel. This should remove the dashpanel and reveal a bunch of wires. ",
        "Still looking forward, use the key on the glove compartment. This should unlock it and you should find some electrical tape and some text on the manual inside. ",
        "Using the message you found on the manual, you notice the first letter of each word spells the colors red, black, blue, and white. Remember this. ",
        "Now that you have the colors for the electrical wires to connect, use the electrical tape on the wires and connect the red, black, blue, and white wires. Power should return to the car! ",
        "Look down and inspect the carpet. Notice that the license plate you find has roman numerals reading 2415. This is the code for the safe! ",
        "Looking forward, enter the code 2415 into the safe and when it swings open you should find a sledgehammer inside. ",
        "Use the sledgehammer on the windshield to smash it open and escape to freedom! Try escaping the next room on your own! ",
      ]
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/pages/walkthrough/car.vue